(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StrutturaDialogController', StrutturaDialogController);

    StrutturaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Struttura', 'Impegno', 'Gae', 'Utente', 'Modello'];

    function StrutturaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Struttura, Impegno, Gae, Utente, Modello) {
        var vm = this;

        vm.struttura = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.impegnos = Impegno.query();
        vm.gaes = Gae.query();
        vm.utentes = Utente.query();
        vm.modellos = Modello.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.struttura.id !== null) {
                Struttura.update(vm.struttura, onSaveSuccess, onSaveError);
            } else {
                Struttura.save(vm.struttura, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:strutturaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
